module.exports = __webpack_public_path__ + "static/dots-7a636214fd23bc5da9c503a27d1d274c.svg";